/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { excelClaim, fileName } from '../../Miscellaneous/export';
import ReactExport from 'react-export-excel';
import c from '../../../../constant';
import useStore from '../../../../store';
import { toFormatCurrency } from '../../../../utils/format';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcel({ year = null, quarter = null, numColumns = 0, claimItem = null, mtplItems = [], ...props }) {
	const { t } = useTranslation();
	const [data, setData] = useState([]);
	const { currentLang: lang } = useStore((state) => state.currentLang);

	useEffect(() => {
		const claims = excelData(claimItem);
		const mtpl = excelDataMtpl(mtplItems);

		const sheets = [...claims];
		if (mtpl) sheets.push(mtpl);

		setData(sheets);
	}, [claimItem, mtplItems, lang, numColumns]);

	function excelData(items = null) {
		if (!items) return null;

		if (claimItem) {
			const claims = excelClaim({
				claimProducts: claimItem?.claimProducts?.filter((el) => el?.productLine?.type === 'General'),
				numColumns,
				lang,
			});
			return [{ name: 'Claim', data: [...claims] }];
		}
		return [];
	}

	function excelDataMtpl(items = null) {
		if (!items) return null;

		let provinces = items?.provinces?.map((province) => ({
			name: province?.name,
			latinName: province?.latinName,
		}));

		provinces.unshift({ name: t('Total'), latinName: t('Total') });
		provinces.unshift({ name: 'ប្រភេទការធានារ៉ាប់រងកាតព្វកិច្ច', latinName: 'Type of MTPL Insurance' });

		let data = items?.cells?.map((row, i) => {
			const isReadOnly = items?.labels?.[i]?.readOnly;

			const total = (row || []).reduce((sum, cell) => {
				const data = String(cell?.value ?? '')
					.replace(/,/g, '')
					.trim();

				if (data === '') return sum;

				const value = Number(data);
				return Number.isFinite(value) ? sum + value : sum;
			}, 0);

			return [
				lang === 'kh' ? items?.labels?.[i]?.titleKhmer : items?.labels?.[i]?.titleEnglish,
				isReadOnly ? '' : toFormatCurrency(total, null),
				...(row?.map((cell) => cell?.value) || []),
			];
		});

		return { name: 'MTPL', provinces, data };
	}

	return (
		<>
			<Box {...props}>
				<ExcelFile
					filename={fileName('Claim', 'General', null, quarter, year)}
					element={
						<>
							<Button
								isLoading={false}
								isDisabled={false}
								onClick={() => null}
								leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
								colorScheme="gray"
								variant="solid"
								size="sm"
								borderRadius={c.borderRadius}
								border="1px solid #bdc3c7"
							>
								{t('Export')}
							</Button>
						</>
					}
				>
					{data?.map((el, i) => {
						if (el?.name === 'MTPL') {
							return (
								<ExcelSheet key={`mtpl-${i}`} data={el?.data} name={t('MTPL')}>
									{el?.provinces?.map((e, i) => {
										return <ExcelColumn key={i} label={lang === 'kh' ? e?.name : e?.latinName} value={`${i}`} />;
									})}
								</ExcelSheet>
							);
						}
						return (
							<ExcelSheet key={i} data={el?.data} name={t(el?.name)}>
								<ExcelColumn label={t('Ordinal')} value="0" />
								<ExcelColumn label={t('Product Line')} value="1" />
								<ExcelColumn label={lang === 'kh' ? 'ចំនួន ((១)_សំណងដែលបានទូទាត់)' : 'Number	((1)_Claim Paid)'} value="2" />
								<ExcelColumn label={lang === 'kh' ? 'ទឹកប្រាក់ ((១)_សំណងដែលបានទូទាត់)' : 'Amount	((1)_Claim Paid)'} value="3" />
								<ExcelColumn label={lang === 'kh' ? 'ចំនួន ((២)_សំណងមិនសង)' : 'Number ((2)_Claim Denied)'} value="4" />
								<ExcelColumn label={lang === 'kh' ? 'ទឹកប្រាក់ ((២)_សំណងមិនសង)' : 'Amount ((2)_Claim Denied)'} value="5" />
								<ExcelColumn label={lang === 'kh' ? 'ចំនួន ((៣)_សំណងមិនទាន់ទូទាត់ចុងខែ)' : 'Number ((3)_Outstanding Claims)'} value="6" />
								<ExcelColumn label={lang === 'kh' ? 'ទឹកប្រាក់ ((៣)_សំណងមិនទាន់ទូទាត់ចុងខែ)' : 'Amount ((3)_Outstanding Claims)'} value="7" />
								<ExcelColumn
									label={lang === 'kh' ? 'ចំនួន ((៤)_បម្រែបម្រួលនៃសំណងមិនទាន់ទូទាត់)' : 'Number ((4)_Change in Outstanding Claims)'}
									value="8"
								/>
								<ExcelColumn
									label={lang === 'kh' ? 'ទឹកប្រាក់ ((៤)_បម្រែបម្រួលនៃសំណងមិនទាន់ទូទាត់)' : 'Amount ((4)_Change in Outstanding Claims)'}
									value="9"
								/>
								<ExcelColumn label={lang === 'kh' ? 'ចំនួន ((១+២+៤)_សំណងកើតឡើង)' : 'Number ((1+2+4)_Claim Incurred)'} value="10" />
								<ExcelColumn label={lang === 'kh' ? 'ទឹកប្រាក់ ((១+២+៤)_សំណងកើតឡើង)' : 'Amount ((1+2+4)_Claim Incurred)'} value="11" />
							</ExcelSheet>
						);
					})}
				</ExcelFile>
			</Box>
		</>
	);
}
